import { Button } from '@app/app/_components/Button/Button';
import { ArrowRightIcon } from '@app/app/_icons/ArrowRightIcon';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseLifeInsuranceResult } from '@app/service/eshop/life/actions/purchaseLifeInsurance';
import { useTranslations } from 'next-intl';
import { saveProgressWithEmail } from '@app/service/eshop/life/actions/saveProgressWithEmail';
import { FormStatus } from '@app/lib/form/contracts/FormStatus';
import { AuthState } from '@app/infrastructure/auth/model/AuthState';

interface Props {
    formState: FormState<PurchaseLifeInsuranceResult>;
    handleSuccess: () => void;
    authState: AuthState;
}

export function SummaryFooter({ formState, handleSuccess, authState }: Props) {
    const t = useTranslations();

    const handleSubmit = async () => {
        const formData = new FormData();
        formData.append('email', formState.data?.formData.email || '');

        if (!formState.data?.formData || !formState.data?.packages) {
            return;
        }

        const result = await saveProgressWithEmail(
            formState.data.formData,
            formState.data.packages,
            { status: FormStatus.Pending },
            formData,
            authState,
        );

        if (result.status === FormStatus.Success) {
            handleSuccess();
        }
    };

    if (!formState.data?.formData || !formState.data?.packages) {
        return null;
    }

    return (
        <>
            <div className="flex w-full flex-col-reverse gap-4 sm:flex-row">
                <Button
                    preventDefault
                    className="w-full"
                    variant="outlined"
                    onClick={handleSubmit}
                    rightAddon={<ArrowRightIcon className="size-4" />}>
                    {t('eshop.life.saveAndContinueLater')}
                </Button>
                <Button className="w-full" rightAddon={<ArrowRightIcon className="size-4" />}>
                    {t('eshop.life.toConcludeTheContract')}
                </Button>
            </div>
        </>
    );
}
